import {
  UPDATE_ALL_COMPANY_USERS,
  UPDATE_COMPANY_LEVEL_OPTIONS, VERIFY_FAILURE, VERIFY_SUCCESS,
  UPDATE_USER_DETAILS
} from "../actions/";

const authReducer = (
  state = {
    // initial state
    user: null,
    isVerifying: true,
    companyUsers: [],
    manufacturers: [],
    storageLocations: [],
    categories: [],
  },
  action
) => {
  switch (action.type) {
    case VERIFY_SUCCESS:
      return {
        ...state,
        user: action.user,
        isVerifying: false,
      };
    case VERIFY_FAILURE:
      return {
        ...state,
        user: null,
        isVerifying: false,
      };
    case UPDATE_ALL_COMPANY_USERS:
      return {
        ...state,
        companyUsers: action.companyUsers,
      };    
    case UPDATE_USER_DETAILS:
      return {
        ...state,
        user: action.user,
      };
    case UPDATE_COMPANY_LEVEL_OPTIONS:
      return {
        ...state,
        manufacturers: [...action.manufacturers],
        storageLocations: [...action.storageLocations],
        categories: [...action.categories],
      };
    default:
      return state;
  }
};

export default authReducer;
